const ActionTypes = require('../constants/ActionTypes');

const UserLogActions = {

    add(sceneKey, intensity, instability) {
        return {
            type: ActionTypes.USER_LOG_ADD,
            payload: {
                sceneKey,
                intensity: typeof intensity !== 'undefined' ? intensity : null,
                instability: typeof instability !== 'undefined' ? instability : null,
            },
        };
    },

    clear(sceneKey, intensity, instability) {
        return {
            type: ActionTypes.USER_LOG_CLEAR,
            payload: {
                sceneKey,
                intensity: typeof intensity !== 'undefined' ? intensity : null,
                instability: typeof instability !== 'undefined' ? instability : null,
            },
        };
    },

};

module.exports = UserLogActions;



// WEBPACK FOOTER //
// ./js/actions/UserLogActions.js